export default "20260921.1 \r\n"